import styled from 'styled-components'
import { getCalendarPopupStyles } from '../style'

const StyledCalendarPopup = styled.div`
    ${getCalendarPopupStyles}
`

export default StyledCalendarPopup
